import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Clock, MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import API from '@/config/api';

// Time Clock / Messages shortcuts, shown only when the center allows them for drivers.
export const DriverExtraLinks = () => {
  const { getAuthHeaders } = useAuth();
  const navigate = useNavigate();
  const [access, setAccess] = useState(null);

  useEffect(() => {
    axios.get(`${API}/staff-access/me`, getAuthHeaders()).then((r) => setAccess(r.data)).catch(() => {});
  }, [getAuthHeaders]);

  if (!access) return null;
  return (
    <>
      {access.driver_allow_timeclock && (
        <Button variant="ghost" size="icon" onClick={() => navigate('/timeclock')} aria-label="Time Clock" data-testid="driver-timeclock-btn">
          <Clock className="w-5 h-5" />
        </Button>
      )}
      {access.driver_allow_messages && (
        <Button variant="ghost" size="icon" onClick={() => navigate('/messages')} aria-label="Messages" data-testid="driver-messages-btn">
          <MessageSquare className="w-5 h-5" />
        </Button>
      )}
    </>
  );
};
